/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.dg = {};

//#endregion

//#region Update

rtAPI.dg.update = function (dgData) {
    this.clear();
    if (!dgData.active) return;
    this.getDGDiv().innerHTML = dgData.message;
    popoutMessagePanel.init();
    return;
}

rtAPI.dg.clear = function () {
    this.getDGDiv().remove();
    return;
}

//#endregion

//#region Render

rtAPI.dg.getDGDiv = function () {

    var dgWrapper = document.getElementById('rtDGWrapper');
    if (!dgWrapper) {
        dgWrapper = document.createElement("div");
        dgWrapper.id = 'rtDGWrapper';
        document.body.insertBefore(dgWrapper, document.body.firstChild);
    }
    dgWrapper.innerHTML = '';
    dgWrapper.style.display = 'block';
    return dgWrapper;
}

//#endregion

//DebugPanelOutput.AppendLine("<div id=""rtDGWrapper"">")
//DebugPanelOutput.AppendLine("<div class=""c-popout-message-panel{0}"">".FormatEx(If(RuntimeMessageIsError, "", " c-popout-message-panel-info")))
//DebugPanelOutput.AppendLine("<div class=""c-popout-message-panel__view"">")
//DebugPanelOutput.AppendLine("<div class=""c-popout-message-panel__content"">")
//DebugPanelOutput.AppendLine("<button type=""button"" class=""sid-debug-panel-close-button c-popout-message-panel__view-close"">Close</button>")
//DebugPanelOutput.AppendLine(Output)
//DebugPanelOutput.AppendLine("</div>")
//DebugPanelOutput.AppendLine("</div>")
//DebugPanelOutput.AppendLine("<div class=""c-popout-message-panel__ctrl"">")
//DebugPanelOutput.AppendLine("<button class=""c-popout-message-panel__ctrl-button"" type=""button"">button</button>")
//DebugPanelOutput.AppendLine("</div>")
//DebugPanelOutput.AppendLine("</div>")
//DebugPanelOutput.AppendLine("</div>")
